module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settingsPage"
  }, [_c('label', [_vm._v("\n        Theme\n        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTheme),
      expression: "currentTheme"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentTheme = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.allThemes), function(theme) {
    return _c('option', {
      domProps: {
        "value": theme.id
      }
    }, [_vm._v(_vm._s(theme.name))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59b79f22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 132
// module chunks = 0